import {
  SafetyCertificateFilled,
  SafetyCertificateOutlined
} from "@ant-design/icons";
import React, { useState } from "react";
import { colors } from "~/theme/colors.js";
import { AuthorisationInfoModal } from "./AuthorisationInfoModal.jsx";

export const AuthorisationStatus = ({
  authorisation = null,
  pilotName = null,
  children,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  if (!authorisation) {
    return (
      <div className="row" style={{ gap: 4, alignItems: "center" }}>
        <SafetyCertificateOutlined style={{ color: colors.gray_light }} />
        {children}
      </div>
    );
  }

  return (
    <div
      className="clickable row"
      style={{ gap: 4, alignItems: "center" }}
      onClick={(e) => {
        e.stopPropagation();
        setModalVisible(true);
      }}
    >
      <SafetyCertificateFilled style={{ color: colors.groen_dark }} />

      <AuthorisationInfoModal
        visible={modalVisible}
        onClose={(e) => {
          if (e) e.stopPropagation();
          setModalVisible(false);
        }}
        authorisation={authorisation}
        pilotName={pilotName}
        canRevoke={false}
      />

      {children}
    </div>
  );
};
